/**
 * This class helps to work with Hash for Data Pages.
 * It has methods for getting and setting hash.
 * Any actions with hash work through this class
 *
 * TODO: Deprecated prefix param
 */

class DataHash {
    /**
     * Hash Prefix
     */

    prefix;

    /**
     * Type hash value
     */

    type;

    /**
     * @param {String} [prefix] The prefix to be ignored in the hash.
     * @param {'simple'|'key_value'} [type] single or array
     */

    constructor(prefix, type) {
        this.prefix = prefix;
        this.type = type;
    }

    /**
     * Get Current Hash Value
     * @return {Array|String|null}
     */
    getHash() {
        let searchParams = new URLSearchParams(window.location.search);

        if (!searchParams) {
            return null;
        }

        let result = [];
        searchParams.forEach((value, key) => {
            if (key.includes('data-')) {
                result.push(key.replace('data-', ''));
                result.push(value);
            }
        });

        return result;
    }

    /**
     * Set hash
     * @param {Array|String} hash
     */

    setHash(hash) {
        let url = new URL(window.location.href);

        let searchParams = url.searchParams;

        for (let i = 0; i < hash.length; i += 2) {
            searchParams.forEach((value, key) => {
                if (key.includes('data-')) {
                    searchParams.delete(key);
                }
            });

            if (!searchParams.has('data-' + hash[i])) {
                searchParams.set('data-' + hash[i], hash[i + 1]);
            }
        }

        window.history.replaceState({}, '', url);
    }

    removeHash() {
        window.history.pushState({}, document.title, window.location.pathname);
    }
}

export default DataHash;
